import { render, staticRenderFns } from "./VideoControls.vue?vue&type=template&id=f70cb862&scoped=true&"
import script from "./VideoControls.vue?vue&type=script&lang=js&"
export * from "./VideoControls.vue?vue&type=script&lang=js&"
import style0 from "./VideoControls.vue?vue&type=style&index=0&id=f70cb862&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70cb862",
  null
  
)

export default component.exports